import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import type { WireSourceHealthRow } from '@logistics/contracts';
import { api } from '../client';
import { expectStatus } from '@/lib/result';

export const SOURCE_HEALTH_KEY = ['health', 'sources'] as const;

/** Every configured source with its status, last sync and latency over 24 hours. */
export function useSourceHealth(): UseQueryResult<WireSourceHealthRow[]> {
  return useQuery({
    queryKey: SOURCE_HEALTH_KEY,
    queryFn: async () => expectStatus(await api.health.sources(), 200).sources,
    refetchInterval: 30_000,
  });
}
